import type { PlaybackClientApp } from '@amzn/amp-playback'

export const clientApp: PlaybackClientApp = { name: 'WebCP', version: '1.0.0' }
